module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marguerite Henry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marguerite Henry (1902–1997) was the beloved author of such classic horse stories as "), _c('I', [_vm._v("King of the Wind")]), _vm._v(", "), _c('I', [_vm._v("Misty of Chincoteague")]), _vm._v(", and "), _c('I', [_vm._v("Stormy, Misty’s Foal")]), _vm._v(", and her work has won several Newbery Awards and Honors. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18mlIjM/tc-custom/9781442487994.jpg?1713839778389",
      "alt": "This image is the cover for the book Misty of Chincoteague"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Misty of Chincoteague\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The timeless classic and beloved story of a wild horse’s gentle filly—winner of a Newbery Honor!")]), _c('br'), _c('br'), _vm._v("On the island of Chincoteague, off the coasts of Virginia and Maryland, lives a centuries-old band of wild ponies. Among them is the most mysterious of all, Phantom, a rarely-seen mare that eludes all efforts to capture her—that is, until a young boy and girl lay eyes on her and determine that they can’t live without her."), _c('br'), _c('br'), _vm._v("The frenzied roundup that follows on the next Pony Penning Day does indeed bring Phantom into their lives, in a way they never would have suspected. Phantom would forever be a creature of the wild. But her gentle, loyal filly Misty is another story altogether . . . "), _c('br'), _c('br'), _c('b', [_vm._v("“A thrilling and long-to-be-remembered tale.” —"), _c('i', [_vm._v("San Francisco Chronicle")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aladdin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0